export var DSJ_LOCAL_STORAGE_KEYS = {
  LEAD_SOURCE: 'dsj_lead_source',
  ONBOARDING_ANSWERS: 'dsj_onboarding'
};